import "./App.css";
import "./App.css";
import React from "react";
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import { ConfigProvider } from "antd";
import MainLayout from "./components/MainLayout";
import Authentication from "./components/Authentication";
import Authorization from "./components/Authorization";
import PageNotFound from "./components/PageNotFound";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import SubjectsTable from "./components/Settings/Subject/SubjectsTable";
import UploadTest from "./components/Tests/UploadTest";
import TestTable from "./components/Tests/TestTable";
import ViewTest from "./components/Tests/ViewTest";
import SubscriptionTypesTable from "./components/Settings/Subscription Types/SubscriptionTypesTable";
import StudentTable from "./components/Students/StudentTable";
import UploadImageToTest from "./components/Tests/UploadImageToTest";
import UploadDailyContent from "./components/Daily Content/UploadDailyContent";
import UploadNotes from "./components/Notes/UploadNotes";
import UploadVideos from "./components/Videos/UploadVideos";
import Result from "./components/Result/Result";
import DetailedResult from "./components/Result/DetailedResult";
import NotesTable from "./components/Notes/NotesTable";
import VideosTable from "./components/Videos/VideosTable";
import NoticeTable from "./components/Notice/NoticeTable";
import DailyContentTable from "./components/Daily Content/DailyContentTable";
import SocialLinkTable from "./components/Social Links/SocialLinkTable";
import PasswordReset from "./components/PasswordReset";
import StudentDetails from "./components/Students/StudentDetails";
import StudentPaymentTable from "./components/Student Payment/StudentPaymentTable";
import DeleteAccount from "./components/DeleteAccount";
import AchievementsTable from "./components/Achievement/AchievementsTable";
import CollabarationTable from "./components/Collabaration/CollabarationTable";
import StudentReviewTable from "./components/Student Review/StudentReviewTable";
import PharmaNewsTable from "./components/Pharama News/PharmaNewsTable";
import JobUpdateTable from "./components/Job Updates/JobUpdateTable";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<Login />}></Route>
      <Route path="/resetpassword" element={<PasswordReset />}></Route>
      <Route path="/delete-account" element={<DeleteAccount />}></Route>
      <Route element={<Authentication />}>
        <Route path="portal" element={<MainLayout />}>
          <Route element={<Authorization allowedRoles={["admin"]} />}>
            <Route path="/portal/dashboard" element={<Dashboard />} />
            <Route path="/portal/students" element={<StudentTable />} />
            <Route
              path="/portal/students-payment"
              element={<StudentPaymentTable />}
            />
            <Route
              path="/portal/setting/subjects"
              element={<SubjectsTable />}
            />
            <Route
              path="/portal/setting/subscription-types"
              element={<SubscriptionTypesTable />}
            />
            <Route path="/portal/test/upload" element={<UploadTest />} />
            <Route path="/portal/tests" element={<TestTable />} />
            <Route path="/portal/test/view/:test_id" element={<ViewTest />} />
            <Route
              path="/portal/test/upload-images/:test_id"
              element={<UploadImageToTest />}
            />
            <Route
              path="/portal/daily-content/upload"
              element={<UploadDailyContent />}
            />
            <Route path="/portal/notes" element={<NotesTable />} />
            <Route path="/portal/notes/upload" element={<UploadNotes />} />
            <Route path="/portal/videos/upload" element={<UploadVideos />} />
            <Route path="/portal/result" element={<Result />} />
            <Route path="/portal/result/detail" element={<DetailedResult />} />
            <Route path="/portal/videos" element={<VideosTable />} />
            <Route path="/portal/notices" element={<NoticeTable />} />
            <Route path="/portal/links" element={<SocialLinkTable />} />
            <Route
              path="/portal/daily-content"
              element={<DailyContentTable />}
            />
            <Route
              path="/portal/students/detail/:student_id"
              element={<StudentDetails />}
            />
            <Route path="/portal/achievement" element={<AchievementsTable />} />
            <Route
              path="/portal/collabaration"
              element={<CollabarationTable />}
            />
            <Route path="/portal/pharma" element={<PharmaNewsTable />} />
            <Route path="/portal/job-update" element={<JobUpdateTable />} />
            <Route
              path="/portal/student-review"
              element={<StudentReviewTable />}
            />
          </Route>
        </Route>
        <Route path="unauthorized" element={<>Unauthorized</>} />
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </>
  )
);

function App() {
  return (
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            headerBg: "rgb(20, 168, 0)",
            colorTextHeading: "rgb(255, 255, 255)",
          },
        },
        token: {
          algorithm: "compactAlgorithm",
          // Seed Token
          colorPrimary: "#1677ff",
          borderRadius: 11,
          fontFamily: "Arial",
          colorTextBase: "#455560",
        },
      }}
    >
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export default App;
